import { useContext, createContext } from "react";
export var useTableContext = function () {
    var context = useContext(TableContext);
    if (context === undefined) {
        throw new Error("A component has been used outside of the Provider components");
    }
    return context;
};
export var TableContext = createContext(undefined);
